module.exports = __webpack_public_path__ + "img/imgstep3.6baea6a2.svg";